import { gql } from '@apollo/client'

export const QUERY_EMPLOYEES = gql`
  query ($roles: [String]) {
    employees(roles: $roles) {
      _id
      first_name
      last_name
      email
      phone_number
      roles
      social_number
      job_tittle
      address
      hour_rate
      bank_account
      tax_card_last_update
      last_seen
      city
    }
  }
`

export const QUERY_EMPLOYEE = gql`
  query ($_id: String!) {
    employee(_id: $_id) {
      _id
      first_name
      last_name
      email
      phone_number
      roles
    }
  }
`

export const CREATE_EMPLOYEE = gql`
  mutation ($employee: EmployeeInput!) {
    createEmployee(employee: $employee) {
      _id
      first_name
      last_name
      email
      city
    }
  }
`

export const DELETE_EMPLOYEE = gql`
  mutation ($_id: String!) {
    deleteEmployee(_id: $_id)
  }
`

export const UPDATE_EMPLOYEE_PASSWORD = gql`
  mutation ($_id: String!, $password: String!) {
    updateEmployeePassword(_id: $_id, password: $password)
  }
`

export const UPDATE_EMPLOYEE = gql`
  mutation ($employee: EmployeeEditInput!) {
    updateEmployee(employee: $employee) {
      _id
      first_name
      last_name
      email
      phone_number
      roles
    }
  }
`
